export class SettingsAlertsEntity {
  constructor() {
    this.alertsAmount = null;
    this.notificationFlag = null;
  }
  getSettingsAlertsEntity() {
    return this;
  }
  setAlertsAmount(alertsAmountValue) {
    this.alertsAmount = alertsAmountValue;
  }
  setNotificationFlag(updatedNotificationFlag) {
    this.notificationFlag = updatedNotificationFlag;
  }
}

export default SettingsAlertsEntity;
